export default function () {
  return {
    cartItems: []
  };
}
